import _concatInstanceProperty from "core-js-pure/stable/instance/concat.js";
import { Weblog } from '@ks/weblogger';
import Radar from '@ks/weblogger/lib/plugins/radar';
export var weblog = new Weblog({
  env: 'production',
  autoPV: true,
  proto: 'v2',
  plugins: [new Radar({
    projectId: 'ba20b73ebd',
    sampling: 1,
    APIHook: function APIHook(apiData) {
      var response = apiData.response;
      var data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
      var code = data.code === undefined ? data.result : data.code;

      if (typeof code === 'string') {
        var _context;

        return {
          response_code: code === 'SUCCESS' ? 1 : 0,
          response_msg: _concatInstanceProperty(_context = "".concat(code, ":")).call(_context, data.errorMsg || data.error_msg || data.msg || ''),
          status: response.status,
          custom_failed: code !== 'SUCCESS'
        };
      }

      return {
        response_code: code,
        response_msg: data.errorMsg || data.error_msg || data.msg || '',
        status: response.status,
        custom_failed: code !== 1
      };
    }
  })]
}, {
  product: 1,
  service_name: 'KUAISHOUPAY'
});